export const SET_USER_IMAGE = "SET_USER_IMAGE";
export const IS_LOADING = "IS_LOADING";
